<template lang="pug">
    .car-equipment
        .content-wrapper
            .label Комплектации Jetta
            .menu
                .line
                .menu-item(v-for="menuItem in menu", :key="menuItem.id", :class="{active: menuItem === selectedItem}", @click="onMenuItemClick(menuItem)")
                    .menu-label {{menuItem.title}}
                    .line
            .equipment-info
                .image-wrapper
                    .image-bg(:style="{backgroundColor: selectedItem.color}")
                    .image(:style="{backgroundImage: 'url('+selectedItem.image+')'}")
                .info-wrapper
                    .info-label Особенности {{selectedItem.title}}
                    .list
                        .list-item(v-for="(title, index) in selectedItem.options", :key="index")
                            .icon
                            .item-label {{title}}
                    .actions
                        .button Конфигуратор
                        .button Записатся на тест-драйв

</template>
<script>
export default {
  name: 'CarEquipment',
  data() {
    return {
      selectedItem: null,
      menu: [
        {
          id: 2,
          title: 'Status',
          image: '/pics/cars/status.png',
          color: 'rgb(26, 56, 104)',
          options: [
            'Цифровая приборная панель',
            'Обивка сидений из искуственной кожи',
            'Колесные диски `Tornado` 7J x 17',
            'Передние светодиодные фары (проекционного типа)',
            'Навигационная система "Discover Media"',
            'Атмосферная подсветка'
          ]
        },
        {
          id: 1,
          title: 'Respect',
          image: '/pics/cars/respect.png',
          color: 'rgb(71, 74, 81)',
          options: [
            'Система бесключевого доступа «Keyless Access»',
            'Мультифункциональное кожаное рулевое колесо (с подогревом)',
            'Климат-контроль Climatronic',
            'Датчики парковки спереди и сзади',
            'Противотуманные фары с подсветкой поворотов',
            'Колесные диски `Sakado` 6.5J x 16'
          ]
        },
        {
          id: 0,
          title: 'Origin',
          image: '/pics/cars/origin.png',
          color: 'rgb(222, 222, 222)',
          options:  [
            'Светодиодные головные фары',
            'Мультимедиа система 6.5’’',
            'App-Connect',
            'Мультифункциональное кожаное рулевое колесо',
            'Подогрев передних сидений',
            'Боковые зеркала с электрорегулировкой и подогревом',
            'Круиз-контроль'
          ]
        },
      ]
    }
  },

  created() {
    this.selectedItem = this.menu[0]
  },

  methods: {
    onMenuItemClick(menuItem) {
      this.selectedItem = menuItem
    }
  }
}
</script>